var React = require('react');

function CloseX (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Close/X Icon"),React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},[React.createElement("path",{"d":"M1,11 L11,1 L1,11 Z","stroke":"currentColor","strokeWidth":"1.5","key":0}),React.createElement("path",{"d":"M1,1 L11,11 L1,1 Z","stroke":"currentColor","strokeWidth":"1.5","key":1})])]);
}

CloseX.defaultProps = {"viewBox":"0 0 12 12","version":"1.1"};

module.exports = CloseX;

CloseX.default = CloseX;
